<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col>
          <h2>Categorias:</h2>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button size="sm" variant="success" v-b-modal.modal-createUberCategory>Crear
            Categoria</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table small responsive striped hover :items="categories" :fields="tableFields">
            <template #cell(buttons)="data">
              <b-button-group vertical>
                <b-button size="sm" variant="warning" @click="editCategory(data.item.id)"
                  >Editar</b-button
                >
              </b-button-group>
            </template>
            <template #cell(items)="data">
              <div class="products-cell">
                <div class="products-badges" :class="{'collapsed': !data.item._showAllProducts && data.item.entities.length > 5}">
                  <b-badge
                    v-for="(entity, index) in data.item.entities"
                    :key="entity.id"
                    v-show="data.item._showAllProducts || index < 5"
                    variant="success"
                    class="mr-1 mb-1 product-badge"
                  >
                    <span class="badge-number">{{ index + 1 }}</span>
                    {{ getItemNameById(entity.id) }}
                  </b-badge>
                  <span v-if="data.item.entities.length === 0" class="text-muted">
                    <i>Sin productos</i>
                  </span>
                </div>
                <button
                  v-if="data.item.entities.length > 5"
                  @click="toggleProducts(data.item)"
                  class="toggle-btn"
                  type="button"
                >
                  <small>
                    <i :class="data.item._showAllProducts ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
                    {{ data.item._showAllProducts ? 'Ver menos' : `Ver ${data.item.entities.length - 5} más` }}
                  </small>
                </button>
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-container>
    <b-modal id="modal-createUberCategory" size="xl" title="Crear Categoria" @ok="createCategory">
      <b-row>
        <b-col>
          <p>Aqui puedes crear las categorias.</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <b-form-group label="Nombre:">
            <b-form-input v-model="actualCategory.title.translations.en" type="text" required></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-group label="Productos">
            <ProductOrderSelector
              v-model="actualCategory.entities"
              :products="items"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import axios from "axios";
import ProductOrderSelector from "./ProductOrderSelector.vue";

export default {
  name: "UberCategories",
  components: {
    ProductOrderSelector,
  },
  data() {
    return {
      categories: [],
      items:[],
      actualCategory: {
        id: "",
        title: {
            translations: {
                en: ""
            }
        },
        entities: [
        ]
      },
      search: "",
      tableFields: [
        { key: "title.translations.en", label: "Titulo" },
        { key: "items", label: "Articulos" },
        { key: "buttons", label: "" }
      ]
    };
  },
  mounted() {
    this.getAllCategories();
    this.getAllItems()
  },
  methods: {
    getItemNamesFromIds(ids){
      console.log("getItemNamesFromIds")
      let items=ids.reduce(function(acum,el){
        acum.push(el.id)
        return acum
      },[])
      console.log(items)
      let x= this.items.reduce(function(p,x){
        if(items.includes(x.id)){
          return x.title.translations.en+(p==""?"":", ")+p
        }else{
          return p
        }
      },"")
      return x
    },
    getItemNameById(id) {
      const item = this.items.find(item => item.id === id);
      return item ? item.label : 'Desconocido';
    },
    toggleProducts(item) {
      this.$set(item, '_showAllProducts', !item._showAllProducts);
    },
    editCategory(id){
      let that = this;
      this.actualCategory.id=id
      axios
        .get("/uber/mastermenu/" + this.$route.params.id + "/category/"+this.actualCategory.id)
        .then(function (response) {
          that.actualCategory = response.data;
          that.$bvModal.show("modal-createUberCategory")
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    getAllCategories() {
      let that = this;
      axios
        .get("/uber/mastermenu/" + this.$route.params.id + "/categories")
        .then(function (response) {
          that.categories = response.data;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    getAllItems() {
      let that = this;
      axios
        .get("/uber/mastermenu/" + this.$route.params.id + "/items")
        .then(function (response) {
          console.log(response.data)
          let x=response.data
          let y=x.map(function(el){
            el.label=el.title.translations.en
            el.value={id:el.id}
            return el
          })
          that.items = y
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    createCategory() {
      let that = this;
      let verb = ""
      if (this.actualCategory.id.length > 0) {
        verb = "PUT"
      } else {
        verb = "POST"
      }
      console.log(verb)
      axios({ method: verb, url: "/uber/mastermenu/" + this.$route.params.id + "/category", data: this.actualCategory })
        .then(function (response) {
          that.actualCategory = response.data;
          that.getAllCategories()
          that.resetactualCategory()
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    getMenu() {
      let that = this;
      axios
        .get("/uber/mastermenu/" + this.$route.params.id + "/category/"+this.actualCategory.id)
        .then(function (response) {
          that.actualCategory = response.data;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    resetactualCategory() {
      this.actualCategory = {
        id: "",
        title: {
            translations: {
                en: ""
            }
        },
        entities: [
        ]
      }
    },
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, {
        title,
        variant,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
  },
};
</script>

<style scoped>
.products-cell {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.products-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  max-height: 120px;
  overflow-y: auto;
  padding: 0.25rem 0;
  align-items: center;
  max-width: 100%;
}

.toggle-btn {
  background: none;
  border: none;
  color: #28a745;
  cursor: pointer;
  padding: 0.25rem 0;
  text-align: left;
  transition: color 0.2s;
  align-self: flex-start;
}

.toggle-btn:hover {
  color: #1e7e34;
  text-decoration: underline;
}

.toggle-btn:focus {
  outline: none;
}

.product-badge {
  font-size: 0.8rem;
  padding: 0.35rem 0.5rem;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  white-space: nowrap;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.badge-number {
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.7rem;
  flex-shrink: 0;
}

/* Mobile optimizations */
@media (max-width: 768px) {
  .product-badge {
    font-size: 0.75rem;
    padding: 0.3rem 0.45rem;
    max-width: 180px;
  }

  .badge-number {
    width: 14px;
    height: 14px;
    font-size: 0.65rem;
  }

  .products-badges {
    max-height: 100px;
  }
}

@media (max-width: 576px) {
  .product-badge {
    font-size: 0.7rem;
    padding: 0.25rem 0.4rem;
    max-width: 140px;
  }

  .badge-number {
    width: 14px;
    height: 14px;
    font-size: 0.65rem;
  }

  .products-badges {
    gap: 0.2rem;
    max-height: 80px;
  }
}
</style>
